import { useState } from 'react'

import { TProcedureFiltersLogicResult } from './ProcedureFilters.types'

export const useProcedureFiltersLogic = (): TProcedureFiltersLogicResult => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return {
    isOpen,
    handleOpen,
    handleClose,
  }
}
